import { Component, OnInit } from '@angular/core';

import { find, some } from 'lodash';
import { forkJoin } from 'rxjs';

import { Cahier } from 'src/app/data/habilitation/models/cahier.model';
import { Habilitation } from 'src/app/data/habilitation/models/habilitation.model';
import { Activite } from 'src/app/data/habilitation/models/activite.model';
import { ActivitesService } from 'src/app/data/habilitation/services/activites/activites.service';
import { CahiersService } from 'src/app/data/habilitation/services/cahiers/cahiers.service';
import { HabilitationsService } from 'src/app/data/habilitation/services/habilitations/habilitations.service';
import { LoaderService } from '../../../core/services/loader/loader.service';

@Component({
    selector: 'app-habilitations',
    templateUrl: './habilitations.component.html',
    styleUrls: ['./habilitations.component.scss'],
    standalone: false
})
export class HabilitationsComponent implements OnInit {
    protected cahiers: Cahier[];
    protected habilitations: Habilitation[];
    activites: Activite[];
    cahiersFiltered: Cahier[];

    constructor(
        protected readonly activitesService: ActivitesService,
        protected readonly cahiersService: CahiersService,
        protected readonly habilitationsService: HabilitationsService,
        protected readonly loaderService: LoaderService
    ) {}

    ngOnInit() {
        setTimeout(() => {
            this.loadHabilitations();
        });
    }

    loadHabilitations() {
        forkJoin(this.activitesService.getActivites(), this.cahiersService.getCahiers(), this.getHabilitations())
            .pipe(this.loaderService.operator())
            .subscribe(result => {
                [this.activites, this.cahiers, this.habilitations] = result;

                this.filterCahiers();
            });
    }

    getHabilitations() {
        return this.habilitationsService.getHabilitations();
    }

    getHabilitation(cahier: Cahier, activite: Activite): Habilitation {
        return find(this.habilitations, (habilitation: Habilitation) => {
            return habilitation.cahier.id === cahier.id && habilitation.activite.id === activite.id;
        });
    }

    filterCahiers() {
        this.cahiersFiltered = this.cahiers.filter(cahier => {
            return some(this.habilitations, (habilitation: Habilitation) => {
                return habilitation.cahier.id === cahier.id;
            });
        });
    }
}
